import axios from '@/axios'

class DocumentsDataService {
  async getAllDocuments(page: number): Promise<any> {
    return axios.get(`/documents/getAllDocuments?page=${page}`)
  }
  async getAllDocumentsForCompany(company_id: any, page: number): Promise<any> {
    return axios.get(`/documents/${company_id}/getAll?page=${page}`)
  }
  async getDocumentById(id: any): Promise<any> {
    return axios.get(`/documents/${id}/get`)
  }
  async downloadFile(id: any): Promise<any> {
    return axios.get(`/documents/${id}/download`)
  }
  async sendReminder(id: any, data: any): Promise<any> {
    return axios.post(`/documents/${id}/sendReminder`, data)
  }
  async add(data: any): Promise<any> {
    return axios.post('/documents/add', data)
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/documents/${id}/update`, data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/documents/${id}/delete`)
  }
  async getDocumentTypes(): Promise<any> {
    return axios.get('/documents/getDocumentTypes')
  }
  async getDocumentSubTypes(): Promise<any> {
    return axios.get('/documents/getDocumentSubTypes')
  }
  async searchDocuments(searchTerm: string): Promise<any> {
    return axios.get(`/documents/search?query=${searchTerm}`);
  }
}
export default new DocumentsDataService()